import { UseQueryOptions, useQuery } from '@lumapps/base-api/react-query';

import { GetDirectoryParams, directoriesQueryKeys, get } from '../api';
import { Directory } from '../types';

export type UseDirectoryOptions = UseQueryOptions<Directory>;

/**
 * Hook in order to retrieve a single directory
 *
 * @returns UseDirectory
 */
export const useDirectory = (params: GetDirectoryParams, options?: UseDirectoryOptions) => {
    return useQuery({
        ...options,
        queryKey: directoriesQueryKeys.getDirectory(params),
        queryFn: async ({ signal }) => {
            const { data } = await get(params, signal);

            return data;
        },
    });
};
